import autobind from 'autobind-decorator';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import type { Events, PAGE_TYPE } from '@core/utils/event-bus';
import {
  EventBus,
  KEY_EDITOR_GET_CODE,
  emitEditorGetCode,
  offEditorCodeResponse,
  offPageInfoUpdate,
  onEditorCodeResponse,
  onPageInfoUpdate,
} from '@core/utils/event-bus';
import { ContextService } from './Context.service';

// 响应类型
interface CodeExecutionResponse {
  id: string; // 对应请求的ID
  [key: string]: any;
}

@Injectable()
export class EventService {
  private pendingRequests = new Map();
  @Inject(forwardRef(() => ContextService))
  public contextService!: ContextService;
  init(){
    onEditorCodeResponse(this.handleResponse);
    onPageInfoUpdate((data) => {
      this.contextService.setPageType(data.pageType as PAGE_TYPE);
    });
  }
  destroy() {
    offEditorCodeResponse(this.handleResponse);
    offPageInfoUpdate((data) => {
      this.contextService.setPageType(data.pageType as PAGE_TYPE);
    });
  }

  @autobind
  private handleResponse(response: CodeExecutionResponse) {
    const resolve = this.pendingRequests.get(response.id);
    if (resolve) {
      resolve(response);
      this.pendingRequests.delete(response.id);
    }
  }

  @autobind
  async execute(event: keyof Events) {
    const id = this.generateRequestId();
    const requestParams = {
      id: id,
    };
    const MAX_TIMEOUT = 1000 * 3;
    return new Promise((resolve, reject) => {
      this.pendingRequests.set(id, resolve);

      EventBus.emit(event, requestParams);

      setTimeout(() => {
        if (this.pendingRequests.has(id)) {
          this.pendingRequests.delete(id);
          reject(new Error('处理超时'));
        }
      }, MAX_TIMEOUT);
    });
  }
  @autobind
  getUserCode() {
    return this.execute(KEY_EDITOR_GET_CODE);
  }
  private generateRequestId(): string {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}
